import axios from 'axios'

const http = axios.create({
    baseURL: (process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/api/v5',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

const onRequestFulfilled = async (request) => {
    let token = localStorage.getItem('token');
    if (token) {
        request.headers.Authorization = token;
    }
    return request;
};

const onRequestRejected = error => {
    return Promise.reject(error)
};

http.interceptors.request.use(
    onRequestFulfilled,
    onRequestRejected
);

function errorResponseHandler(error) {
    try {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        }
    } catch (e) {
        // nothing to do
    }
    return Promise.reject(error);
}

function responseHandler(response) {
    return response;
}

// apply interceptor on response
http.interceptors.response.use(
    responseHandler,
    errorResponseHandler
);

export default http;